<template>
<div class="crm-nav">
  <!-- 主菜单 -->
  <div class="crm-nav-main">
    <ul>
      <li
        v-for="(item, index) in menuTreeList"
        :key="index"
        @mouseenter="handleMenuEnter(item.children, index)"
        @mouseleave="handleMenuLeave(index)">
        <a @click="handleMenuClick(item.url)" :class="{'cur': $route.fullPath.includes(item.url)}">
          <img :src="item.url | srcFilter" alt="" style="width: 20px;height: 20px;" />
          <span v-show="!isShrink">{{item.name}}</span>
          <img v-show="!isArrowLeft[index] && item.children.length && !isShrink" src="@/images/icon/arrow-right.png" alt="">
          <img v-show="isArrowLeft[index] && item.children.length && !isShrink" src="@/images/icon/arrow-left.png" alt="">
        </a>
        <div class="arrow" v-show="isArrowLeft[index] && item.children.length"></div>
      </li>
    </ul>
  </div>

  <!-- 子菜单 -->
  <div
    v-show="isSubMenuShow && subMenuData.length"
    class="crm-nav-sub"
    :class="{'shrink-ml': isShrink}"
    @mouseenter="isSubMenuShow = true"
    @mouseleave="isSubMenuShow = false"
    >
    <ul>
      <li
        v-for="(secItem, secIndex) in subMenuData"
        :key="secIndex"
        class="nav-sub-item"
        :class="{ 'third-menu': !secItem.children.length }"
        @click="$router.push(secItem.url)"
      > 
        {{ secItem.children.length ? '' : secItem.name }}
        <ul v-if="secItem.children.length">
          <p class="sec-menu" v-if="secItem.name">{{ secItem.name }}</p>
          <li
            v-for="thirdItem in secItem.children"
            :key="thirdItem.url"
            @click.stop="handleMenuClick(thirdItem.url)"
            class="third-menu"
            :class="{'third-menu-cur': $route.fullPath.includes(thirdItem.url)}">
            {{ thirdItem.name }}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import getMenu from '~services/menu';
import crmNav from '@/components/layouts/crmNav';

export default {
  components: {
    crmNav,
  },
  props: {
    isShrink: {
      type: Boolean,
    },
  },
  data() {
    return {
      menu: [],
      isArrowLeft: {},
      isSubMenuShow: false,
      subMenuData: null,
    };
  },
  async mounted() {
    // parentId 为0 查全部菜单树 可以写死嗷
    await this.getMenuTree({ parentId: 0 })
  },

  filters: {
    srcFilter(url) {
      switch (url) {
        case '/home':
          return require('@/images/icon/nav-home.png')

        case '/clue':
          return require('@/images/icon/nav-clue.png')

        case '/null':
          return require('@/images/icon/nav-custom.png')
        
        case '/business/opportunity':
          return require('@/images/icon/nav-busi.png')
        
        case '/visit':
          return require('@/images/icon/nev-visit.png')
        
        case '/project':
          return require('@/images/icon/icon_xm.png')
        
        case '/compact':
          return require('@/images/icon/nav-contract.png')

        case '/date':
          return require('@/images/icon/nav-data.png')

        case '/knowledge': 
          return require('@/images/icon/nav-knowledge.png')
        
        case '/audit':
          return require('@/images/icon/nav-auditiong.png')

        case '/teammanage': 
          return require('@/images/icon/nav-team.png')

        default:
          return require('@/images/icon/nav-setting.png')
      }
    },
  },

  computed: {
    ...mapGetters({
      authenticated: 'authority/authenticated',
      auth: 'authority/auth',
      menuTreeList: 'backstage/menuTreeList',
    }),
  },
  methods: {
    ...mapActions({
      getMenuTree: 'backstage/getMenuTree',
    }),
  
    handleMenuEnter(menu, index) {
      this.isArrowLeft[index] = true;
      this.isSubMenuShow = true;
      this.subMenuData = menu;
    },
    handleMenuLeave(index) {
      this.isArrowLeft[index] = false;
      this.isSubMenuShow = false;
    },
    handleMenuClick(route) {
      if (route) {
        this.$router.push(route);
      }
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/const.less';

.crm-nav {
  .shrink-ml {
    margin-left: -140px;
  }
  // 主菜单
  .crm-nav-main {
    display: inline-block;
    ul {
      padding: 0;
      li {
        padding: 0 10px;
        a {
          display: flex;
          align-items: center;
          height:20px;
          padding: 10px;
          line-height: 40px;
          border-radius: 4px;
          color: @color--white;
          cursor: pointer;
          &:hover {
            font-weight: @fw--bold;
            background: @nav-item-hover;
          }
          span {
            width: 110px;
            margin-left:10px;
          }
        }
        .cur {
          font-weight: @fw--bold;
          background: @nav-item-hover;
        }
        .arrow {
          float: right;
          margin-right: -10px;
          margin-top: -24px;
          width: 0;
          height: 0;
          border-width: 4px;
          border-style: solid;
          border-color: transparent @bg--white transparent transparent;
        }
      }
    }

  }
  // 子菜单
  .crm-nav-sub {
    overflow-y: auto;
    box-sizing: border-box;
    z-index: 10;
    position: absolute;
    left: 200px;
    top: 50px;
    width: 300px;
    height: calc(100% - 50px);
    padding-top: 20px;
    background-color: @bg--white;
    box-shadow: @box-shadow;
    ul {
      padding: 0;
      width: 100%;
    }
    li {
      box-sizing: border-box;
      width: 100%;
    }
    .nav-sub-item {
      .sec-menu {
        display: inline-block;
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding-left: 30px;
        background-color: @bg-secmenu;
        color: @color--placeholder;
      }
    }
    .third-menu {
        width: 280px;
        height: 40px;
        margin: 0 10px;
        padding-left: 40px;
        line-height: 40px;
        color: @color--primary;
        border-radius: 4px;
        cursor: pointer;
        &:hover {
          background-color: @nav-subitem-hover;
        }
      }
      .third-menu-cur {
        background-color: @nav-subitem-hover;
      }
  }
}
</style>
